import { Label, Text } from "@jsq/ds/core";
import { FormDatePicker, useFormContext } from "@jsq/ds/forms";
import { Icon } from "@jsq/ds/icons";
import { useDocumentRefreshFeatureFlag } from "~/pages/Compliance/flags";
import { SPACING } from "~/styles/variables";
import { isDocumentExpired } from "../../../utils";
import {
  expiredDateWrapper,
  expiredIcon,
  expiredMessage,
  expiredText,
} from "./styles_vanilla.css";

interface Props {
  name?: string;
  label?: string;
  maxDate?: Date;
  readonly: boolean;
  showExpiredWarning?: boolean;
  hasIcon?: boolean;
  isFull?: boolean;
  placeholderText?: string;
}

const DateFieldFormValue = ({
  name = "date",
  label = "Date",
  maxDate,
  readonly,
  showExpiredWarning = false,
  hasIcon,
  isFull,
  placeholderText,
}: Props) => {
  const { values, initialValues } = useFormContext<Record<string, unknown>>();
  const isDocumentRefreshEnabled = useDocumentRefreshFeatureFlag();

  const currentValue = values[name] as Date | undefined;
  const initialValue = initialValues[name] as Date | undefined;
  const documentExpiryDate = values["documentExpiryDate"] as Date | undefined;
  const secondaryDocumentType = values["secondaryDocumentType"] as string | undefined;

  const isExpired =
    showExpiredWarning &&
    isDocumentRefreshEnabled &&
    isDocumentExpired(currentValue, initialValue, documentExpiryDate, secondaryDocumentType);

  return (
    <div css={{ marginBottom: SPACING.MEDIUM }} data-testid="date-field">
      <Label className="stacked-bottom-md">{label}</Label>
      <FormDatePicker
        name={name}
        aria-label={label}
        disabled={readonly}
        maxDate={maxDate}
        wrapperClassName={isExpired ? expiredDateWrapper : undefined}
        hasIcon={hasIcon}
        isFull={isFull}
        placeholderText={placeholderText}
      />
      {isExpired && (
        <span className={expiredMessage}>
          <Icon type="exclamation-circle" className={expiredIcon} />
          <Text className={expiredText}>Document has expired</Text>
        </span>
      )}
    </div>
  );
};

export default DateFieldFormValue;
